module.exports = __webpack_public_path__ + "img/40.85482df3.png";